"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  *{font-size: ", ";}\n"], ["\n  *{font-size: ", ";}\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  *{color: ", "}\n  background-color: transparent;\n  border: 1px solid ", ";\n"], ["\n  *{color: ", "}\n  background-color: transparent;\n  border: 1px solid ", ";\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .75);\n"], ["\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .75);\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  opacity: .2;\n  pointer-events: none;\n"], ["\n  opacity: .2;\n  pointer-events: none;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  *{\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none; \n  }\n  cursor: pointer;\n  user-select: none;\n  border: none;\n  outline: none;\n  color: white;\n  padding: 5px 12px;\n  border-radius: 5px;\n  background-color: ", ";\n  transition:all .1s;\n  :active{\n    transition:all .05s;\n    transform: scale(.98);\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  *{\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    text-decoration: none; \n  }\n  cursor: pointer;\n  user-select: none;\n  border: none;\n  outline: none;\n  color: white;\n  padding: 5px 12px;\n  border-radius: 5px;\n  background-color: ", ";\n  transition:all .1s;\n  :active{\n    transition:all .05s;\n    transform: scale(.98);\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bg = function bg(props) {
  return props.bg || 'rgb(17, 17, 17)';
};
var color = function color(props) {
  return props.color || 'white';
};
var clearColor = function clearColor(props) {
  return props.color || 'black';
};
var size = function size(props) {
  if (props.size === 'xsm') {
    return '.9rem';
  } else if (props.size === 'sm') {
    return '1rem';
  } else if (props.size === 'md') {
    return '1.1rem';
  } else if (props.size === 'lg') {
    return '1.25rem';
  } else {
    return '.9rem';
  }
};
var hasBgProp = function hasBgProp(props) {
  return props.bg && (0, _styledComponents.css)(_templateObject, bg);
};
var hasSizeProp = function hasSizeProp(props) {
  return props.size && (0, _styledComponents.css)(_templateObject2, size);
};
var hasClearProp = function hasClearProp(props) {
  return props.clear && (0, _styledComponents.css)(_templateObject3, clearColor, bg);
};
var hasShadowProp = function hasShadowProp(props) {
  return props.shadow && (0, _styledComponents.css)(_templateObject4);
};
var hasDisabledProp = function hasDisabledProp(props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject5);
};

var Base = _styledComponents2.default.button(_templateObject6, color, size, bg, hasSizeProp, hasBgProp, hasClearProp, hasShadowProp, hasDisabledProp);

var Button = function Button(_ref) {
  var className = _ref.className,
      type = _ref.type,
      name = _ref.name,
      onClick = _ref.onClick,
      form = _ref.form,
      text = _ref.text,
      to = _ref.to,
      size = _ref.size,
      bg = _ref.bg,
      color = _ref.color,
      clear = _ref.clear,
      disabled = _ref.disabled,
      shadow = _ref.shadow;
  return _react2.default.createElement(
    Base,
    {
      className: className,
      type: type,
      name: name,
      onClick: onClick,
      form: form,
      text: text,
      href: to,
      size: size,
      bg: bg,
      color: color,
      clear: clear,
      disabled: disabled,
      shadow: shadow },
    to ? _react2.default.createElement(
      "a",
      { href: to },
      text
    ) : _react2.default.createElement(
      "div",
      null,
      text
    )
  );
};

exports.default = Button;